import { ShieldCheck, Award, Clock, Leaf } from "lucide-react";

const reasons = [
  {
    icon: ShieldCheck,
    title: "100% Bacteria Free",
    desc: "Our advanced cleaning process eliminates 99.99% of bacteria, viruses, and harmful contaminants.",
  },
  {
    icon: Award,
    title: "Certified Technicians",
    desc: "All our technicians are trained and certified in water tank hygiene and safety protocols.",
  },
  {
    icon: Clock,
    title: "Same Day Service",
    desc: "Need urgent cleaning? We offer same-day service availability across Gurugram.",
  },
  {
    icon: Leaf,
    title: "Eco-Friendly Process",
    desc: "We use biodegradable, food-grade cleaning agents that are safe for the environment.",
  },
];

export default function WhyChooseUs() {
  return (
    <section data-testid="why-choose-section" className="py-20 md:py-24 bg-surface">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <p className="text-sky font-medium text-sm uppercase tracking-[0.2em] mb-3">
            Why Tank Buddy
          </p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight text-navy">
            Why Choose Us
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((r, i) => (
            <div
              key={r.title}
              data-testid={`trust-signal-${i}`}
              className="text-center group"
            >
              <div className="w-16 h-16 rounded-2xl bg-white border border-slate-200 shadow-sm flex items-center justify-center mx-auto mb-5 group-hover:shadow-md group-hover:border-sky/50 transition-all duration-300">
                <r.icon className="w-7 h-7 text-sky" />
              </div>
              <h3 className="font-heading font-semibold text-lg text-navy mb-2">
                {r.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                {r.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
